import { Tabs, Theme, useStyles, VFlow } from 'bold-ui'
import { PageContainer } from 'components/layout/PageContainer'
import { TabLink } from 'components/route'
import { useCabecalhoMinimizado } from 'hooks/useCabecalhoMinimizado'
import React from 'react'
import { useRouteMatch } from 'react-router'

import { AtendimentoCidadaoHeader } from './AtendimentoCidadaoHeader'

export interface AtendimentoHeaderProps {
  cidadaoId: ID
  renderFolhaRosto?: boolean
  renderSoap?: boolean
  renderVacinacao?: boolean
  renderHistorico?: boolean
  renderAntecedentes?: boolean
  renderCadastroCidadao?: boolean
  renderEscutaInicial?: boolean
  labelEscutaPreAtendimento?: string
}

AtendimentoHeader.defaultProps = {
  renderFolhaRosto: true,
  renderSoap: true,
  renderVacinacao: false,
  renderHistorico: true,
  renderAntecedentes: true,
  renderCadastroCidadao: true,
  renderEscutaInicial: false,
}

export function AtendimentoHeader(props: AtendimentoHeaderProps) {
  const {
    cidadaoId,
    renderFolhaRosto,
    renderSoap,
    renderVacinacao,
    renderHistorico,
    renderAntecedentes,
    renderCadastroCidadao,
    renderEscutaInicial,
    labelEscutaPreAtendimento,
  } = props
  const minimizado = useCabecalhoMinimizado()
  const match = useRouteMatch()

  const { classes } = useStyles((theme) => createStyles(theme, minimizado))

  return (
    <div className={classes.container}>
      <PageContainer fluid>
        <VFlow>
          <AtendimentoCidadaoHeader cidadaoId={cidadaoId} minimizado={minimizado} />

          <Tabs style={classes.tabs}>
            {renderFolhaRosto && <TabLink to={`${match.url}/folha-rosto`}>Folha de rosto</TabLink>}
            {renderSoap && <TabLink to={`${match.url}/soap`}>SOAP</TabLink>}
            {renderEscutaInicial && <TabLink to={`${match.url}/escuta-inicial`}> {labelEscutaPreAtendimento}</TabLink>}
            {renderVacinacao && <TabLink to={`${match.url}/vacinacao`}>Vacinação</TabLink>}
            {renderHistorico && <TabLink to={`${match.url}/historico`}>Histórico</TabLink>}
            {renderAntecedentes && <TabLink to={`${match.url}/antecedentes`}>Antecedentes</TabLink>}
            {renderCadastroCidadao && <TabLink to={`${match.url}/cadastro-cidadao`}>Cadastro do cidadão</TabLink>}
          </Tabs>
        </VFlow>
      </PageContainer>
    </div>
  )
}

const createStyles = (theme: Theme, minimizado: boolean) => ({
  container: {
    borderBottom: `1px solid ${theme.pallete.divider}`,
    backgroundColor: theme.pallete.surface.main,
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 9,
    boxShadow: minimizado && `0 1px 5px 0 ${theme.pallete.divider}, 0 2px 1px -1px ${theme.pallete.divider}`,
  } as React.CSSProperties,
  tabs: {
    borderBottomWidth: 0,
  },
})
